import request from '@/api/axios';


// 示例：
export function getCountryList() {
    return request({
      url: '/api/product/v1/country/list',
      method: 'get'
    });
  }


export function getProductByCountry(countryCode, autoRenew, iccid) {
    const params = {
        countryCode,
        autoRenew,
    };
    if (iccid) {
        params.iccid = iccid;
    }
    return request({
        url: '/api/product/v1/product/list',
        method: 'get',
        params,
    });
}